<template>
    <account-verification-provider
        v-slot="{ isWhiteLabeled, contact, isLoading, sendVerificationEmail, skipVerification }"
    >
        <account-verification-view
            :is-white-labeled="isWhiteLabeled"
            :contact="contact"
            :is-loading="isLoading"
            @send-verification-email="sendVerificationEmail"
            @skip-verification="skipVerification"
        />
    </account-verification-provider>
</template>

<script>
    import AccountVerificationProvider from '../providers/dashboard/AccountVerificationProvider.vue';
    import AccountVerificationView from '../data-views/dashboard/AccountVerificationView.vue';

    export default {
        name: 'AccountVerificationRouterView',
        components: {
            AccountVerificationView,
            AccountVerificationProvider
        }
    };
</script>
